<template>
  <div
    v-if="showCommentsToggle"
    class="comments-toggle"
  >
    <v-badge
      :model-value="Boolean(unresolvedThreadCount)"
      color="grey"
      :content="unresolvedThreadCount"
    >
      <v-btn
        variant="outlined"
        min-width="48"
        width="48"
        class="comments-icon"
        :active="currentTab === 'comments'"
        aria-label="Show Comments"
        @click="setCurrentTab('comments')"
      >
        <DpplSvg file-name="icons/Icon_Comment" />
      </v-btn>
    </v-badge>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useCommenting } from '@/stores/commenting/commenting';
import { useDocumentRightPanel } from '@/stores/document/rightPanel';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

const rightPanelStore = useDocumentRightPanel();
const { showCommentsToggle, unresolvedThreadCount } = storeToRefs(useCommenting());
const { currentTab } = storeToRefs(rightPanelStore);
const { setCurrentTab } = rightPanelStore;
</script>

<style lang="less" scoped>
.comments-icon {
  border-color: @stroke-default;
  svg {
    color: @icon-default;
  }
}
</style>
